import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PrintAgentService {
  api = 'http://127.0.0.1:1818';

  constructor(private httpClient: HttpClient) {}

  printOrder(order: any): Observable<any> {
    return this.httpClient.post(this.api + '/print', order).pipe(timeout(5000));
  }
  getPrinters(): Observable<any[]> {
    return this.httpClient
      .get<any[]>(`${this.api}/printers`)
      .pipe(timeout(5000));
  }
}
